import { Component, OnInit, AfterViewInit,ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '../../../node_modules/@angular/common/http';
import { GridOptions } from '../../../node_modules/ag-grid-community';
import { AlertService, AuthenticationService, UserService, PushNotificationsService } from '../_services';
import { User, Call } from '../_models';
import { element } from '@angular/core/src/render3';
import { ChildMessageRenderer } from './cellRenderer';
import * as moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatepickerOptions } from 'ng2-datepicker';
import * as frLocale from 'date-fns/locale/en';
import { interval, Subscription } from 'rxjs';
import { Key } from 'protractor';
@Component({
  selector: 'app-unallocatecalllog',
  templateUrl: './unallocatecalllog.component.html',
  styleUrls: ['./unallocatecalllog.component.scss']
})
export class UnallocatecalllogComponent implements OnInit, AfterViewInit {
  searchForm: FormGroup;
  busmodelForm: FormGroup;
  private gridOptions: GridOptions;
  private columnDefs;
  private defaultColDef;
  public tempGridList: any = [];
  public abcList: any = [];
  private userID: string = "";
  public rawData: Call[];
  private isFromDns: string = "";
  private startindex: number = 0;
  private displaynumber: number = 20;
  private lastindexofgrid: number = 0;
  private totalrawcount: number = 0;
  private frameworkComponents;
  private context;
  private gridApi;
  private gridColumnApi;
  private rowSelection;
  private colResizeDefault;
  private domLayout;
  private Extensions = [];
  private IsCallFilter: Boolean = false;
  private showBusAllotedModal: Boolean = false;
  private mdlRecordDate: any;
  private mdlDirection: any;
  private mdlDuration: any;
  private mdlDurationValue: any = 0;
  private mdltelephone: any;
  private mdlbillable: boolean = true;
  private mdlAccount: string = "";
  private mdlAccountId: string = "";
  private mdlPreviousAccount: string = "";
  private mdlPreviousAccountId: string = "";
  private mdlisbatchbus: boolean = false;
  private mdlAccountName: any;
  private mdlRate: any;
  private mdlTotalCost: any;
  private mdlRecordID: any;
  private mdlServerID: any;
  private mdlComment: string = "";
  private AccountList: any = [];
  private DeviceList: any = [];
  private TempDeviceList: any = [];
  private DirectionList: any = [];
  private AccountSelectList: any;
  private tempSelecteAccountID: string = "";
  private tempSelecteAccount: string = "";
  //Batch Allocation
  private BatchAllocation: boolean = false;
  private BatSelRawCount: number = 0;
  private BatTotalRawCount: number = 0;
  //keyword='Account';
  private themeWrapper = document.querySelector('body');
  //for private popup
  private mdlprivatePhoneNumber: string = "";
  private mdlprivateRecordID: any;
  private mdlprivatecomment: string = "";
  private mdlprivateserverid: string = "";
  private mdlprivaterate: any;
  private mdlisbatchprivate: boolean = false;
  private isgraybackground: boolean = false;
  gridsubscription: Subscription;
  gridintervalId: number;
  newunallocatecount:boolean=true;
  //datetime formate
  fromoptions: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2099,
    displayFormat: 'YYYY-MM-DD',
    barTitleFormat: 'YYYY-MM-DD',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0,
    locale: frLocale,
    //minDate: new Date(Date.now()), // Minimal selectable date
    //maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'YYYY-MM-DD',
    placeholder: 'YYYY-MM-DD', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {},
    fieldId: 'searchFromDate',
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };
  tooptions: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2099,
    displayFormat: 'YYYY-MM-DD',
    barTitleFormat: 'YYYY-MM-DD',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0,
    locale: frLocale,
    minDate: new Date(Date.now()), // Minimal selectable date
    //maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'YYYY-MM-DD',
    placeholder: 'YYYY-MM-DD', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'searchtoDate',
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };
  // private searchPhoneNumber:string;
  // private searchDirection:string;
  // private searchDevice:string;
  // private searchExt:string;

  //Device DropDown 
  // selectdeviceoption = [
  //   { "key": "", "value": "Device" },
  //   { "key": "LANDLINE", "value": "LANDLINE" },
  //   { "key": "MOBILE", "value": "MOBILE" },
  // ];
  selectdevicekey = "value";

  //Direction DropDown 
  // selectdirectionoption = [
  //   { "key": "", "value": "Direction" },
  //   { "key": "INCOMING", "value": "INCOMING" },
  //   { "key": "OUTGOING", "value": "OUTGOING" },
  // ];
  selectdirectionkey = "value";

  //Extention Dropdown 
  selectextkey = "value";
  //DropDown Style Class
  styleGuide: {
    caretClass: 'caret',
    selectBoxClass: 'dropdown-wrapper',
    selectMenuClass: 'dropdown',
    optionsClass: 'option'
  }
  constructor(private changeDetectorRef: ChangeDetectorRef,private _notificationService: PushNotificationsService, private userservice: UserService, private alertService: AlertService, private formBuilder: FormBuilder) {
    this.searchForm = this.formBuilder.group({
      searchPhoneNumber: [''],
      searchDirection: [{ "key": "", "value": "Direction" }],
      searchDevice: [{ "key": "", "value": "Device" }],
      searchExt: [{ "key": "", "value": "Ext" }],
      searchFromDate: [''],
      searchToDate: ['']
      //password: ['', [Validators.required,Validators.minLength(8),Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]]
    });
    this.userservice.GetListAccounts(localStorage.getItem("user")).subscribe(
      response => {
        let data = response;
        if (data["StatusCode"] == "200") {
          this.AccountList = data["Data"];
        }
      });
    this.context = { componentParent: this };
    this.frameworkComponents = {
      childMessageRenderer: ChildMessageRenderer
    };
  
  }

  ngOnInit() {
    if (localStorage.getItem("PrimaryColor") && localStorage.getItem("SecondaryColor")) {
      this.isgraybackground = true;
    }
    this.userID = localStorage.getItem("user");
    this.gridOptions = <GridOptions>{};
    this.createParentColumnDefs()
    this.getdata();
    //this.newunallocatecount=false;
    this.defaultColDef = { resizable: true};
    this.Extensions = [];
    this.Extensions = [{ "key": "", "value": "Ext" }];
    if (localStorage.getItem('Extensions')) {
      let tempextention = localStorage.getItem('Extensions').split(',');
      if (tempextention.length > 0) {
        tempextention.forEach((value, key, i) => {
          this.Extensions.push({ "key": value.trim(), "value": value.trim() })
        });
      }
    }
    this.getdevice();
    this.getdirection();
 
    const source = interval(2000);
    this.gridsubscription = source.subscribe(val => this.updateunallocatedgrid());
    
  }

  getdevice(){
    this.DeviceList = [];
    this.userservice.DeviceList(localStorage.getItem('ServerId')).subscribe(
      response => {
        this.DeviceList = [{ "key": "", "value": "Device" }];

        let data = response;
        if (data["StatusCode"] == "200") {
          let DeviceData = data["Data"];

          if (DeviceData.length > 0) {
           DeviceData.forEach((value, key, i) => {
            this.DeviceList.push({ "key": value.trim(), "value": value.trim() })
          });
          }
        }
      });
  }

  getdirection(){
    
    this.userservice.DirectionList(localStorage.getItem('ServerId')).subscribe(
      response => {
        let data = response;
        this.DirectionList=[{ "key": "", "value": "Direction" }];
        if (data["StatusCode"] == "200") {
          let DirectionData = data["Data"];

          if (DirectionData.length > 0) {
            DirectionData.forEach((value, key, i) => {
              this.DirectionList.push({ "key": value.trim(), "value": value.trim() })
            });
          
          }
         
        }
      });
  }
  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  createParentColumnDefs() {
    this.gridOptions.columnDefs = [

      {
        headerName: "Call Date & Time",
        field: "RecordDate",
        width: 180,
        cellRenderer: (data) => {
          return moment(data.value).format('YYYY-MM-DD HH:mm')
        },
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        suppressSizeToFit: true
      },
      {
        headerName: "Direction",
        field: "Direction",
        width: 100
      },
      {
        headerName: "Device",
        field: "RecordType",
        width: 100
      },
      {
        headerName: "Ext",
        field: "Extension",
        width: 100
      },
      {
        headerName: "Phone Number",
        field: "PhoneNumber",
        width: 120
      },
      {
        headerName: "Duration",
        field: "Duration",
        width: 90
      },
      // {
      //   headerName: "Previously Acct",
      //   field: "AccountName",
      //   width: 140
      // },
      {
        headerName: "Previously Code",
        field: "Account",
        width: 140
      },
      {
        headerName: "Action",
        cellRenderer: 'childMessageRenderer',
        colId: "params",
        field: "Action",
        width: 150,
        minWidth: 50
      }

    ];
    this.rowSelection = "multiple";
    this.colResizeDefault = "shift";
    this.domLayout = "autoHeight";
  }
  getdata() {
    this.BatchAllocation = false;
    let fromdate: string = "";
    let todate: string = "";
    if (this.f.searchFromDate.value != "") {
      fromdate = moment(this.f.searchFromDate.value).format();
    }
    if (this.f.searchToDate.value != "") {
      todate = moment(this.f.searchToDate.value).format();
    }
    this.tempGridList = [];
    this.userservice.GetUnallotedCallLog(25, this.lastindexofgrid, this.userID, this.f.searchPhoneNumber.value, this.f.searchDirection.value.key, this.f.searchDevice.value.key, this.f.searchExt.value.key, fromdate, todate).subscribe(
      response => {
        let data = response;
        if (data["StatusCode"] == "200") {
          let CallList = data["Data"];

          this.tempGridList = CallList["Call"];
          this.totalrawcount = CallList["CallCount"];
          if(this.newunallocatecount)
          {
          localStorage.setItem("UnAllocateCallCount", this.totalrawcount.toString());
          this.newunallocatecount=false;
          }
          if (this.totalrawcount > 0) {
            document.title = "Revoco";
            let tital = document.title;
            let newTitle = '(' + this.totalrawcount + ') ' + tital;
            document.title = newTitle;
          }

          if (this.tempGridList.length > 0) {
            this.lastindexofgrid = this.tempGridList.length;
          }

          this.gridOptions.api.setRowData(this.tempGridList);
        } else {
          this.gridOptions.api.setRowData(this.tempGridList);
          this.lastindexofgrid = 0;
          this.totalrawcount = 0;
        }



      },
      error => {
        this.alertService.showNotification('error', "Some thing went wrong.")

      })
  }

  updateunallocatedgrid() {
    if (sessionStorage.getItem("UnAllocateCallCount")) {
      this.lastindexofgrid=0;
      this.getdata();
      sessionStorage.removeItem("UnAllocateCallCount");
    }
  }
  updatelatestcalllog() {
    this.BatchAllocation = false;
    let fromdate: string = "";
    let todate: string = "";
    if (this.f.searchFromDate.value != "") {
      fromdate = moment(this.f.searchFromDate.value).format();
    }
    if (this.f.searchToDate.value != "") {
      todate = moment(this.f.searchToDate.value).format();
    }
    this.tempGridList = [];
    this.userservice.GetUnallotedCallLog(25, this.lastindexofgrid, localStorage.getItem("user"), this.f.searchPhoneNumber.value, this.f.searchDirection.value.key, this.f.searchDevice.value.key, this.f.searchExt.value.key, fromdate, todate).subscribe(
      response => {
        let data = response;
        if (data["StatusCode"] == "200") {
          let CallList = data["Data"];

          this.tempGridList = CallList["Call"];
          this.totalrawcount = CallList["CallCount"];
          localStorage.setItem("UnAllocateCallCount", this.totalrawcount.toString());
          if (this.totalrawcount > 0) {
            document.title = "Revoco";
            let tital = document.title;
            let newTitle = '(' + this.totalrawcount + ') ' + tital;
            document.title = newTitle;
          }

          if (this.tempGridList.length > 0) {
            this.lastindexofgrid = this.tempGridList.length;
          }

          this.gridOptions.api.setRowData(this.tempGridList);
        } else {
          this.gridOptions.api.setRowData(this.tempGridList);
          this.lastindexofgrid = 0;
          this.totalrawcount = 0;
        }



      },
      error => {
        this.alertService.showNotification('error', "Some thing went wrong.")

      })
  }
  LoadMoreData() {
    this.BatchAllocation = false;
    this.gridOptions.api.showLoadingOverlay();
    let fromdate: string = "";
    let todate: string = "";
    if (this.f.searchFromDate.value != "") {
      fromdate = moment(this.f.searchFromDate.value).format();
    }
    if (this.f.searchToDate.value != "") {
      todate = moment(this.f.searchToDate.value).format();
    }
    this.userservice.GetUnallotedCallLog(25, this.lastindexofgrid, this.userID, this.f.searchPhoneNumber.value, this.f.searchDirection.value.key, this.f.searchDevice.value.key, this.f.searchExt.value.key, fromdate, todate).subscribe(
      response => {
        let data = response;
        if (data["StatusCode"] == "200") {
          let CallList = data["Data"];
          this.totalrawcount = CallList["CallCount"];
          CallList["Call"].forEach((value, key, i) => {
            this.tempGridList.push(value)

          });
          if (this.tempGridList.length > 0) {
            this.lastindexofgrid = this.tempGridList.length;
          }

          this.gridOptions.api.setRowData(this.tempGridList);
          this.gridOptions.api.hideOverlay();
        }
        else {
          this.gridOptions.api.hideOverlay();
        }


      },
      error => {
        this.alertService.showNotification('error', "Some thing went wrong.")

      })
  }

  ngAfterViewInit() {
    setTimeout(() => {

      this.defaultColDef = { resizable: true };
    });


  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setGridAutoHeight(true)
    params.api.sizeColumnsToFit();
  }
  onSelectionChanged() {
    var selectedRows = this.gridApi.getSelectedRows();
    var selectedRowsString = "";
    selectedRows.forEach(function (selectedRow, index) {
      if (index > 5) {
        return;
      }
      if (index !== 0) {
        selectedRowsString += ",";
      }
      selectedRowsString += selectedRow.RecordType;
    });
    if (selectedRows.length >= 2) {
      this.BatchAllocation = true;
      this.BatSelRawCount = selectedRows.length;
      this.BatTotalRawCount = this.lastindexofgrid;
      // selectedRowsString += " - and " + (selectedRows.length - 5) + " others";
    }
    else {
      this.BatchAllocation = false;
      this.BatSelRawCount = 0;
    }
    // document.querySelector("#selectedRows").innerHTML = selectedRowsString;
  }
  methodFromParent(cell) {
    this.mdlprivateRecordID = cell.RecRecordID;
    this.mdlprivatePhoneNumber = cell.PhoneNumber;
    this.mdlprivatecomment = "";
    this.mdlprivaterate = cell.Rate;
    this.mdlisbatchprivate = false;
    this.mdlprivateserverid = cell.ServerID;
    document.getElementById("btnprivatemodelpopup").click();
  }

  btn_BatchPrivateClick() {
    var selectedRows = this.gridApi.getSelectedRows();
    var selectedRowsString = "";
    var selectedServerString = "";
    let serverid: string = "";
    selectedRows.forEach(function (selectedRow, index) {
      if (index !== 0) {
        selectedRowsString += ",";
        selectedServerString += ",";
      }
      selectedRowsString += selectedRow.RecRecordID;
      selectedServerString += selectedRow.ServerID;
    });
    this.mdlprivateRecordID = selectedRowsString;
    this.mdlprivateserverid = selectedServerString;
    this.mdlprivatePhoneNumber = selectedRows[0].PhoneNumber;
    this.mdlprivaterate = selectedRows[0].Rate;
    this.mdlisbatchprivate = true;
    document.getElementById("btnprivatemodelpopup").click();
  }

  Yes_PrivateCall_Click() {
    if (this.mdlprivatecomment == "") {
      this.alertService.showNotification('error', "Add comment.")
    }
    else {
      let recordid: string = String(this.mdlprivateRecordID);
      let unallocatecall = {
        RecordID: recordid + ",",
        UserID: localStorage.getItem("user"),
        AccountID: null,
        Rate: 0,
        Comment: this.mdlprivatecomment,
        Billable: false,
        Personal: true,
        ServerID: this.mdlprivateserverid + ","
      };
      this.userservice.UpdateCall(unallocatecall)
        .subscribe(
          data => {
            if (data["StatusCode"] == "200") {
              document.getElementById("btnprivatemodelpopup").click();
              this.lastindexofgrid = 0;
              this.getdata();
            }
            else {
              this.alertService.showNotification('error', data["Message"])
            }
          });
    }
  }
  No_PrivateCall_Click() {
    document.getElementById("btnprivatemodelpopup").click();
  }

  CallFilterClick(cell) {
    let fromdate: string = "";
    let todate: string = "";
    if (this.f.searchFromDate.value != "") {
      fromdate = moment(this.f.searchFromDate.value).format();
    }
    if (this.f.searchToDate.value != "") {
      todate = moment(this.f.searchToDate.value).format();
    }
    this.BatchAllocation = false;
    if (!this.IsCallFilter) {
      this.lastindexofgrid = 0;
      this.userservice.GetUnallotedCallLog(25, this.lastindexofgrid, this.userID, cell, this.f.searchDirection.value.key, this.f.searchDevice.value.key, this.f.searchExt.value.key, fromdate, todate).subscribe(
        response => {
          let data = response;
          if (data["StatusCode"] == "200") {
            let CallList = data["Data"];
            this.IsCallFilter = true;
            this.tempGridList = CallList["Call"];
            this.totalrawcount = CallList["CallCount"];
            if (this.tempGridList.length > 0) {
              this.lastindexofgrid = this.tempGridList.length;
            }

            this.gridOptions.api.setRowData(this.tempGridList);
            this.gridOptions.api.hideOverlay();
          } else {
            this.gridOptions.api.setRowData(this.tempGridList);
            this.gridOptions.api.hideOverlay();
          }

        },
        error => {
          this.alertService.showNotification('error', "Some thing went wrong.")

        })
    }
    else {
      this.lastindexofgrid = 0;
      this.userservice.GetUnallotedCallLog(25, this.lastindexofgrid, this.userID, "", this.f.searchDirection.value.key, this.f.searchDevice.value.key, this.f.searchExt.value.key, fromdate, todate).subscribe(
        response => {
          let data = response;
          if (data["StatusCode"] == "200") {
            let CallList = data["Data"];
            this.IsCallFilter = false;
            this.tempGridList = CallList["Call"];
            this.totalrawcount = CallList["CallCount"];
            if (this.tempGridList.length > 0) {
              this.lastindexofgrid = this.tempGridList.length;
            }

            this.gridOptions.api.setRowData(this.tempGridList);
            this.gridOptions.api.hideOverlay();
          } else {
            this.gridOptions.api.setRowData(this.tempGridList);
            this.gridOptions.api.hideOverlay();
          }

        },
        error => {
          this.alertService.showNotification('error', "Some thing went wrong.")

        })
    }


  }
  SearchCallSubmit() {
    this.lastindexofgrid = 0;
    this.getdata();
  }

  ResetFilter() {

    this.searchForm = this.formBuilder.group({
      searchPhoneNumber: [''],
      searchDirection: [{ "key": "", "value": "Direction" }],
      searchDevice: [{ "key": "", "value": "Device" }],
      searchExt: [{ "key": "", "value": "Ext" }],
      searchFromDate: [''],
      searchToDate: ['']
      //password: ['', [Validators.required,Validators.minLength(8),Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]]
    });
    this.lastindexofgrid = 0;
    this.IsCallFilter = false;
    let ele = (<HTMLInputElement>document.getElementById('searchFromDate'));
    ele.value = "";
    let ele2 = (<HTMLInputElement>document.getElementById('searchtoDate'));
    ele2.value = "";

    this.getdata();
  }

  //Grid Bus Button Click
  GrdBusButtonClick(cell) {
    this.mdlAccount = "";
    this.mdlAccountId = "";
    this.mdlComment = "";
    this.mdlRecordID = cell.RecRecordID;
    this.mdlServerID = cell.ServerID;
    this.mdlRecordDate = moment(cell.RecordDate).format('YYYY-MM-DD HH:mm');
    this.mdlDirection = cell.Direction;
    this.mdlDuration = cell.Duration;
    this.mdltelephone = cell.PhoneNumber;
    this.mdlPreviousAccount = cell.Account;
    this.mdlPreviousAccountId = cell.AccountID;
    this.mdlAccountName = cell.AccountName;
    this.mdlRate = cell.Rate;
    this.mdlTotalCost = cell.TotalCost.toFixed(2);
    this.mdlPreviousAccountId = cell.AccountID;
    this.mdlDurationValue = cell.DurationValue;
    this.mdlisbatchbus = false;
    document.getElementById("AllocatedBusBtn").click();

    //     this.showBusAllotedModal = true;

  }
  //from date change event
  fromchange(event) {

    this.tooptions = {
      minYear: 1970,
      maxYear: 2099,
      displayFormat: 'YYYY-MM-DD',
      barTitleFormat: 'YYYY-MM-DD',
      dayNamesFormat: 'dd',
      firstCalendarDay: 0,
      locale: frLocale,
      minDate: this.f.searchFromDate.value,
      barTitleIfEmpty: 'YYYY-MM-DD',
      placeholder: 'YYYY-MM-DD', // HTML input placeholder attribute (default: '')
      addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
      addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
      fieldId: 'searchtoDate',
      useEmptyBarTitle: false,
    }
    if (this.f.searchFromDate.value != "") {
      let ele = (<HTMLInputElement>document.getElementById('searchFromDate'));
      ele.value = moment(this.f.searchFromDate.value).format("YYYY-MM-DD");
    }
  }
  //to date change event
  tochange(event) {

    if (this.f.searchToDate.value != "") {
      let ele = (<HTMLInputElement>document.getElementById('searchtoDate'));
      ele.value = moment(this.f.searchToDate.value).format("YYYY-MM-DD");
    }
  }

  AllocateBus_Click() {
    if (this.mdlAccount == "") {
      this.alertService.showNotification('error', "Add account.")
    }
    else if (this.mdlComment == "") {
      this.alertService.showNotification('error', "Add comment.")
    }
    else {
      document.getElementById("AllocatedBusBtnConfirmation").click();
    }

  }
  btnyes_busconfirmation() {
    let recordid: string = String(this.mdlRecordID);

    let unallocatecall = {
      RecordID: recordid + ",",
      UserID: localStorage.getItem("user"),
      AccountID: this.mdlAccountId,
      Rate: this.mdlbillable ? this.mdlRate : 0,
      Comment: this.mdlComment,
      Billable: this.mdlbillable,
      Personal: false,
      ServerID: this.mdlServerID + ","
    };
    this.userservice.UpdateCall(unallocatecall)
      .subscribe(
        data => {
          if (data["StatusCode"] == "200") {
            document.getElementById("AllocatedBusBtnConfirmation").click();
            document.getElementById("AllocatedBusBtn").click();
            this.lastindexofgrid = 0;
            this.getdata();
          }
          else {
            this.alertService.showNotification('error', data["Message"])
          }
        });

  }
  btnno_busconfirmation() {
    document.getElementById("AllocatedBusBtnConfirmation").click();
    setTimeout(() => {
      this.themeWrapper.classList.add("modal-open");
    }, 500);
  }
  AccountSelection_Click() {
    document.getElementById("AccountSelectionBtn").click();
  }
  CalculateCost(value) {
    if (value > 0) {
      this.mdlTotalCost = (this.mdlDurationValue * value).toFixed(2);
    }
    else {
      this.mdlTotalCost = 0;
    }
  }
  getMinutesFromTime(time: string): any {
    let split = time.split(':');
    let hours = split[0];
    let minutes = split[1];
    let second = split[2];
    return ((parseFloat(hours) * 60) + parseFloat(minutes) + (parseFloat(second) / 60)).toFixed(2)
  }

  selectAccountEvent(event) {
    this.tempSelecteAccount = event.Account;
    this.tempSelecteAccountID = event.AccountID;
    this.AccountSelectList = event.Account;
    // this.mdlAccount=event.Account;
    // this.mdlAccountId=event.AccountID;
  }
  // onChangeSearch(event){
  //   this.mdlAccount="";
  //   this.mdlAccountId="";
  // }

  // selectAutoAccountEvent(event)
  // {
  //   this.mdlAccount=event.Account;
  //   this.mdlAccountId=event.AccountID;
  // }

  SelectAccount_BtnClick(autocomplete) {
    this.AccountSelectList = "";
    if (this.tempSelecteAccount != "" && this.tempSelecteAccountID != "") {
      this.mdlAccount = this.tempSelecteAccount;
      this.mdlAccountId = this.tempSelecteAccountID;
      this.tempSelecteAccount = "";
      this.tempSelecteAccountID = "";
    }
    document.getElementById("AccountSelectionBtn").click();
    setTimeout(() => {
      this.themeWrapper.classList.add("modal-open");
    }, 500);

  }
  AddAccount(Account) {
    if (Account) {
      this.mdlAccount = Account;
      this.mdlAccountId = this.mdlPreviousAccountId;
    }
  }

  Btn_BatchBussinessClick() {
    this.mdlAccount = "";
    this.mdlAccountId = "";
    var selectedRows = this.gridApi.getSelectedRows();
    var selectedRowsString = "";
    let duretionvalue: number = 0;
    var selectedServerString = "";
    let serverid: string = "";
    selectedRows.forEach(function (selectedRow, index) {
      if (index !== 0) {
        selectedRowsString += ",";
        selectedServerString += ",";
      }
      selectedRowsString += selectedRow.RecRecordID;
      if (selectedRow.DurationValue != null) {
        duretionvalue += Number(selectedRow.DurationValue);
      }

      selectedServerString += selectedRow.ServerID;


    });

    this.mdlRecordID = selectedRowsString;
    this.mdlServerID = selectedServerString;
    this.mdlComment = "";
    this.mdlRecordDate = moment(selectedRows[0].RecordDate).format('YYYY-MM-DD HH:mm');
    this.mdlDirection = selectedRows[0].Direction;
    this.mdlDuration = selectedRows[0].Duration;
    this.mdltelephone = selectedRows[0].PhoneNumber;
    this.mdlPreviousAccount = selectedRows[0].Account;
    this.mdlPreviousAccountId = selectedRows[0].AccountID;
    this.mdlAccountName = selectedRows[0].AccountName;
    this.mdlRate = selectedRows[0].Rate;

    this.mdlPreviousAccountId = selectedRows[0].AccountID;
    this.mdlDurationValue = duretionvalue;
    this.mdlTotalCost = (this.mdlDurationValue * this.mdlRate).toFixed(2);
    //this.mdlDurationValue=selectedRows[0].DurationValue;
    this.mdlisbatchbus = true;
    document.getElementById("AllocatedBusBtn").click();

  }

  ModelClsBtn() {
    setTimeout(() => {
      this.themeWrapper.classList.add("modal-open");
    }, 500);
  }
  ngOnDestroy() {
    this.gridsubscription && this.gridsubscription.unsubscribe();
  }

}
